import templateUrl from "./statement-of-benefits-details.html";

export const statementOfBenefitsDetailsComponent = {
  templateUrl,

  bindings: {
    details: "<",
  },

  controller: class StatementOfBenefitsDetailsComponent {
    constructor($state, $sce, StatementOfBenefitsService) {
      "ngInject";

      this.$state = $state;
      this.$sce = $sce;
      this.StatementOfBenefitsService = StatementOfBenefitsService;
    }
    trustedHtml(plainText) {
      return this.$sce.trustAsHtml(plainText);
    }
    onEdit() {
      this.$state.go("statementOfBenefitsEdit");
    }

    _showEditOption() {
      return this.details.desc !== " ";
    }
  },
};



// WEBPACK FOOTER //
// ./src/app/components/statement-of-benefits/statement-of-benefits-details/statement-of-benefits-details.component.js